import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import { useIntentBehavior } from '../../../../providers/IntentBehavior';
import { getTestIds } from '../../../../utils/TestIds';
import { Checkbox } from '../../../Checkbox';
import { ActionsCell } from '../cells/ActionsCell/ActionsCell';
import { isMultilineColumn } from '../columns/columnsState';
import { RowTransition } from '../RowTransition/RowTransition';
import { ACTIONS_COLUMN_WIDTH, CHECKBOX_GUTTER_WIDTH, COMPACT_ROW_HEIGHT, ROW_HEIGHT } from '../table.constants';
import styles from '../table.module.scss';
import { TableRowCell } from './TableRowCell';
export function TableRow(props) {
    const { row, columns, trailingColumn, rowActions, actionSlot, frozenOffsets = {}, frozenPrefixLength = 0, isScrolledX = false, hasColumnsBeyondEnd, minWidth, rowStyle, nested = false, entering = false, compact = false, pending = false, virtualizeOptions = false, hasSelection = false, now, selection, onRowClick, rowHref, intent, heapId, editing, testId } = props;
    const { getDisabled } = useIntentBehavior();
    const isDisabledByIntent = intent != null && getDisabled(intent);
    const hasMultilineColumn = columns.some((column)=>isMultilineColumn(column.column));
    const rowHeight = compact ? COMPACT_ROW_HEIGHT : ROW_HEIGHT;
    const isClickable = onRowClick != null || rowHref != null;
    const rowAttributes = {
        'data-testid': testId,
        'data-heapid': heapId,
        className: cn(styles.row, {
            [styles.nestedRow]: nested,
            [styles.clickable]: isClickable && !isDisabledByIntent,
            [styles.selected]: (selection === null || selection === void 0 ? void 0 : selection.isSelected) === true,
            [styles.intentDisabled]: isDisabledByIntent
        }),
        'data-disabled': isDisabledByIntent ? true : undefined,
        onClick: ()=>onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick(row),
        style: {
            minWidth,
            height: hasMultilineColumn ? undefined : rowHeight,
            minHeight: rowHeight,
            '--dt-row-height': "".concat(rowHeight, "px"),
            '--dt-trailing-width': trailingColumn == null ? undefined : "".concat(trailingColumn.width, "px")
        }
    };
    const testIds = getTestIds(testId);
    const cells = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            columns.map((column, index)=>/*#__PURE__*/ _jsx(TableRowCell, {
                    column: column,
                    row: row,
                    isFrozen: index < frozenPrefixLength,
                    isFrozenEdge: index === frozenPrefixLength - 1 && !!isScrolledX,
                    left: frozenOffsets[column.id],
                    pending: pending,
                    virtualizeOptions: virtualizeOptions,
                    now: now,
                    editing: editing,
                    cellTestId: testIds.cell(column.id),
                    valueTestId: testIds.value(column.id)
                }, column.id)),
            /*#__PURE__*/ _jsx("div", {
                className: styles.trailingGutter
            })
        ]
    });
    const rowBody = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            hasSelection && /*#__PURE__*/ _jsx("div", {
                className: styles.checkboxGutter,
                style: {
                    width: CHECKBOX_GUTTER_WIDTH
                },
                onClick: (event)=>event.stopPropagation(),
                children: selection != null && selection.isSelectable && /*#__PURE__*/ _jsx(Checkbox, {
                    bi: selection.bi,
                    checked: selection.isSelected,
                    onChange: (event)=>selection.onChange(event.target.checked),
                    testId: testIds.select()
                })
            }),
            rowHref != null ? /*#__PURE__*/ _jsx(Link, {
                className: styles.rowLink,
                to: rowHref,
                children: cells
            }) : cells,
            (rowActions != null || actionSlot != null) && /*#__PURE__*/ _jsx("div", {
                className: cn(styles.actionsGutter, styles.revealHost, {
                    [styles.scrolledEndEdge]: hasColumnsBeyondEnd === true
                }),
                style: {
                    width: ACTIONS_COLUMN_WIDTH
                },
                onClick: (event)=>event.stopPropagation(),
                children: rowActions != null ? /*#__PURE__*/ _jsx(ActionsCell, {
                    actions: rowActions,
                    row: row,
                    testId: testIds.actions()
                }) : actionSlot
            }),
            trailingColumn != null && /*#__PURE__*/ _jsx(TableRowCell, {
                column: trailingColumn,
                row: row,
                isFrozen: false,
                isFrozenEdge: false,
                pending: pending,
                virtualizeOptions: virtualizeOptions,
                now: now,
                editing: editing,
                trailing: true,
                cellTestId: testIds.cell(trailingColumn.id),
                valueTestId: testIds.value(trailingColumn.id)
            }, trailingColumn.id)
        ]
    });
    return /*#__PURE__*/ _jsx(RowTransition, {
        entering: entering,
        children: /*#__PURE__*/ _jsx("div", {
            className: cn(styles.rowCard, styles[rowStyle], {
                [styles.selectedCard]: (selection === null || selection === void 0 ? void 0 : selection.isSelected) === true
            }),
            style: {
                minWidth
            },
            "data-entering": entering ? true : undefined,
            "data-testid": testIds.card(),
            children: /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, rowAttributes), {
                children: rowBody
            }))
        })
    });
}
